import {
  QaiAlertComponent,
  QaiAppHeaderComponent,
  QaiAppLogoComponent,
  QaiAppNavAnchorComponent,
  QaiAppNavButtonComponent,
  QaiAppNavListComponent,
  QaiAppNavUserComponent,
  QaiAssignmentCardComponent,
  QaiAssignmentsListComponent,
  QaiAvatarComponent,
  QaiBadgeComponent,
  QaiBreadcrumbListComponent,
  QaiButtonAnchorComponent,
  QaiButtonComponent,
  QaiCardTitleAnchorComponent,
  QaiCardTitleButtonComponent,
  QaiCardTitleComponent,
  QaiDialogComponent,
  QaiEmptyComponent,
  QaiFloatingDirective,
  QaiGlyphComponent,
  QaiIconComponent,
  QaiInnerWrapComponent,
  QaiItemGridComponent,
  QaiLabelComponent,
  QaiLinkButtonComponent,
  QaiLoadingComponent,
  QaiMenuButtonComponent,
  QaiMenuComponent,
  QaiMenuItemAnchorComponent,
  QaiMenuItemButtonComponent,
  QaiMenuSectionComponent,
  QaiMultiSelectComponent,
  QaiResultCardComponent,
  QaiSearchableSelectComponent,
  QaiScoreComponent,
  QaiScoresListComponent,
  QaiSelectComponent,
  QaiSkillHighlightComponent,
  QaiSlotDirective,
  QaiTabDirective,
  QaiTabsComponent,
  QaiTooltipComponent,
  QaiUserInfoComponent,
  QaiReportingCardComponent,
  QaiOverallScoreComponent,
  QaiSectionScoreComponent
} from '@qai/ui';

export const qaiUiImports = [
  QaiAlertComponent,
  QaiAppHeaderComponent,
  QaiAppLogoComponent,
  QaiAppNavAnchorComponent,
  QaiAppNavButtonComponent,
  QaiAppNavListComponent,
  QaiAppNavUserComponent,
  QaiAssignmentCardComponent,
  QaiAssignmentsListComponent,
  QaiAvatarComponent,
  QaiBadgeComponent,
  QaiBreadcrumbListComponent,
  QaiButtonAnchorComponent,
  QaiButtonComponent,
  QaiCardTitleAnchorComponent,
  QaiCardTitleButtonComponent,
  QaiCardTitleComponent,
  QaiDialogComponent,
  QaiEmptyComponent,
  QaiFloatingDirective,
  QaiGlyphComponent,
  QaiIconComponent,
  QaiInnerWrapComponent,
  QaiItemGridComponent,
  QaiItemGridComponent,
  QaiLabelComponent,
  QaiLinkButtonComponent,
  QaiLoadingComponent,
  QaiMenuButtonComponent,
  QaiMenuComponent,
  QaiMenuItemAnchorComponent,
  QaiMenuItemButtonComponent,
  QaiMenuSectionComponent,
  QaiMultiSelectComponent,
  QaiResultCardComponent,
  QaiSearchableSelectComponent,
  QaiScoreComponent,
  QaiScoresListComponent,
  QaiSelectComponent,
  QaiSkillHighlightComponent,
  QaiSlotDirective,
  QaiTabDirective,
  QaiTabsComponent,
  QaiTooltipComponent,
  QaiUserInfoComponent,
  QaiReportingCardComponent,
  QaiOverallScoreComponent,
  QaiSectionScoreComponent,
];
